module.exports = __webpack_public_path__ + "img/1.6-711x800.68b9b20a.jpg";